import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';

import SignIn from '../components/SignIn';
import KHAuth from '../utils/KHAuth';
import useLogger from '../utils/useLogger';

export default function SignInScreen({
  initialForm,
}: {
  initialForm: React.ComponentProps<typeof SignIn>['initialForm'];
}): JSX.Element {
  const logger = useLogger();
  const history = useHistory();
  const location = useLocation<{ from: { [key: string]: string } } | undefined>();

  function redirect() {
    const cognitoUser = KHAuth.getCognitoUserOrNull();

    if (cognitoUser != null && cognitoUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
      history.replace('/change-password');
      return;
    }

    if (!KHAuth.isSignedIn()) {
      history.replace('/booking/booking-redirect');
      return;
    }

    history.replace('/');
  }

  function onSignIn() {
    // TODO(alessio): implement an escape hatch for folks that are both Schedulers and Techs so that they can switch if needed.
    if (KHAuth.isSignedIn() && location.state?.from?.pathname != null) {
      history.replace(location.state.from);
      return;
    }

    redirect();
  }

  useEffect(() => {
    if (KHAuth.isSignedIn()) redirect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <SignIn initialForm={initialForm} onSignIn={onSignIn} logger={logger} />;
}
